import React from 'react'

const TexplorationLayout = (props) => {

    return (
        <div className='bg-slate-100'>{props.children}</div>
    )
}

export default TexplorationLayout